import { Component } from '@angular/core';
import { LoginService } from 'app/services/login/login.service';

@Component({
  selector: 'app-credito-servifin',
  templateUrl: './credito-servifin.component.html',
  styleUrls: ['./credito-servifin.component.scss']
})
export class CreditoServifinComponent {

  constructor(private loginService: LoginService) {}

  clickGuard() {
    this.loginService.clickGuard = true;
  }
}
